module.exports = __webpack_public_path__ + "img/ipars4.cf95484c.jpg";